import React, { useEffect, useRef, useState } from "react"

interface SectionRefs {
  [key: string]: React.RefObject<HTMLDivElement>
}

interface UseScrollSpyResult {
  activeSection: string
  sectionRefs: SectionRefs
}

const useScrollSpy = (sections: string[]): UseScrollSpyResult => {
  const [activeSection, setActiveSection] = useState<string>("")
  const sectionRefs = useRef<SectionRefs>(
    sections.reduce((acc, sectionId) => {
      acc[sectionId] = React.createRef()
      return acc
    }, {} as SectionRefs)
  )

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id)
          }
        })
      },
      { rootMargin: "0px", threshold: 0.2 } // Configure as needed
    )

    Object.values(sectionRefs.current).forEach((ref) => {
      if (ref.current) observer.observe(ref.current)
    })

    return () => {
      Object.values(sectionRefs.current).forEach((ref) => {
        if (ref.current) observer.unobserve(ref.current)
      })
    }
  }, [sections])

  return { activeSection, sectionRefs: sectionRefs.current }
}

export default useScrollSpy
